import './index.css';
// import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
// import awsconfig from '@/aws-exports';

import App from './App';
import reportWebVitals from './reportWebVitals';

// awsconfig.aws_appsync_graphqlEndpoint =
// process.env.REACT_APP_GRAPHQL_ENDPOINT || awsconfig.aws_appsync_graphqlEndpoint;
// Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
